import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import MigrationSection from '../../sections/MigrationSection/MigrationSection';
import ContactSection from '../../sections/ContactSection/ContactSection';
import { GlobalStyle } from '../../global/global';
import ContentImage from '../../sections/ContentImageSection/ContentImageSection';
import StyledButton from '../../components/Button/Button';
import { Box, Flex, Text, Image, Hide, Divider } from '@chakra-ui/react';
import TabsSection from '../../sections/TabsSection/TabsSection';
import { StyledHeading, StyledHighlight } from '../../sections/CalltoActionSection/styles';

interface Props {}

const heroImage = {
    url: 'https://www.idosell.com/panel/file-gate.php?id=309296&ext=.jpeg',
    alt: 'Zdjęcie wyróżniające w hero - strona szablonów standardowych',
};

export default function StandardTemplatesPage(props: Props) {
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />

            <HeroSection
                title={
                    <>
                        Zaczynasz przygodę z{' '}
                        <span style={{ whiteSpace: 'nowrap' }}>e-commerce</span>?
                    </>
                }
                image={heroImage}
                badgeLabel="SZABLON SKLEPU"
                subTitle="Wybierz szablon Standard na start i przekonaj się, czego dokładnie potrzebujesz żeby skutecznie sprzedawać."
            />
            <Flex
                className="homepage containerIdosellPages"
                direction={'column'}
                gap={{
                    base: 16,
                    md: 24,
                }}
                py={{
                    base: 16,
                    md: 24,
                }}
            >
                <Flex gap={16} alignItems={'center'}>
                    <Hide below="lg">
                        <Box
                            display={'flex'}
                            justifyContent={'center'}
                            alignItems={'center'}
                            minW={'25%'}
                        >
                            <Image src="https://www.iai-system.com/panel/file-gate.php?id=309254&ext=.jpg" />
                        </Box>
                    </Hide>
                    <Flex flexDirection={'column'}>
                        <StyledHeading style={{ textAlign: 'left' }}>
                            Czy szablon Standard jest dla ciebie?
                        </StyledHeading>
                        <Text
                            fontSize={{
                                base: 'md',
                                md: 'lg',
                            }}
                            mt={5}
                        >
                            Szablon Standard jest idealnym wyborem dla przedsiębiorców i właścicieli
                            małych firm, którzy stawiają swoje pierwsze kroki w świecie e-commerce.
                            <br />
                            <br />
                            Jeśli dopiero zaczynasz budować swoją obecność online i nie posiadasz
                            jeszcze dokładnie sprecyzowanych potrzeb czy wymagań dotyczących
                            personalizacji e-sklepu, to wybór szablonu Standard jest dla ciebie
                            najkorzystniejszym rozwiązaniem.
                            <br />
                            <br />
                            Ten rodzaj szablonu został zaprojektowany z myślą o uniwersalności.
                            Dzięki temu jest on <b>odpowiedni dla wielu branż.</b> Szablon Standard
                            oferuje prosty i intuicyjny interfejs użytkownika, który ułatwia
                            nawigację zarówno dla właścicieli sklepów, jak i dla ich klientów.
                        </Text>
                        <Flex
                            mt={{
                                base: 6,
                                md: 8,
                            }}
                        >
                            <StyledButton
                                href={'https://www.idosell.com/pl/demo/try-idosell-demo-for-free/'}
                                style={'default'}
                                target="_blank"
                            >
                                Zamów darmowe DEMO i sprawdź szablony Standard
                            </StyledButton>
                        </Flex>
                    </Flex>
                </Flex>
                <Box
                    _before={{
                        content: '""',
                        position: 'absolute',
                        height: '100%',
                        top: 0,
                        width: '100vw',
                        marginLeft: '50%',
                        left: '-50vw',
                        zIndex: -2,
                        backgroundColor: 'rgba(238, 238, 238, 1)',
                    }}
                    position={'relative'}
                >
                    <ContentImage
                        title="Szablon Standard to baza każdego sklepu w IdoSell"
                        image={{
                            url: 'https://www.idosell.com/panel/file-gate.php?id=309280&ext=.png',
                            alt: 'Zdjęcie sklepu klasyka',
                        }}
                        subtitle="Chcesz rozwijać biznes i spersonalizować swój e-sklep? Wszystkie szablony indywidualne powstają na bazie Standardu."
                        layout_order="image_right"
                        padding="3rem 0 3rem 0"
                        bgColor="grey"
                    >
                        <Text mt={2}>
                            Na start masz zapewnioną obsługę wszystkich najnowszych rozwiązań od
                            IdoSell oraz mechanizmów, które umożliwią bezproblemowe prowadzenie
                            sprzedaży przez sklep internetowy, przy zachowaniu estetycznej
                            prezentacji produktów.
                        </Text>
                    </ContentImage>
                </Box>
                <Flex direction={'column'}>
                    <StyledHeading>Warianty szablonu Standard</StyledHeading>
                    <StyledHighlight $style={'normal'}>
                        Sprawdź, dla kogo są nasze rozwiązania
                    </StyledHighlight>
                    <Flex
                        flexWrap={'wrap'}
                        gap={{
                            base: 4,
                            lg: 0,
                        }}
                        mt={7}
                        justifyContent={'space-between'}
                    >
                        <Flex
                            direction={'column'}
                            justifyContent={'space-between'}
                            backgroundColor={'#EEE'}
                            px={{
                                base: 8,
                                md: 4,
                            }}
                            py={8}
                            minH={{ lg: '350px' }}
                            w={{
                                base: '100%',
                                lg: '24%',
                            }}
                        >
                            <Box>
                                <Text
                                    minH={{ base: '30px', md: '75px' }}
                                    fontWeight={'600'}
                                    fontSize={'2xl'}
                                    // borderBottom={'3px solid black'}
                                    position={'relative'}
                                    _after={{
                                        position: 'absolute',
                                        height: '3px',
                                        width: '40px',
                                        content: '""',
                                        bottom: '-10px',
                                        left: 0,
                                        background: 'black',
                                    }}
                                >
                                    Uniwersalny
                                </Text>
                                <Text mt={8} mb={{ base: 6, lg: 0 }}>
                                    Idealnie sprawdzi się na start w każdej branży. Jeśli nie masz
                                    jeszcze sprecyzowanych potrzeb, to jest to szablon dla ciebie!
                                </Text>
                            </Box>
                        </Flex>
                        {/* --- */}
                        <Flex
                            direction={'column'}
                            justifyContent={'space-between'}
                            backgroundColor={'#EEE'}
                            px={{
                                base: 8,
                                md: 4,
                            }}
                            py={8}
                            minH={{ lg: '350px' }}
                            w={{
                                base: '100%',
                                lg: '24%',
                            }}
                        >
                            <Box>
                                <Text
                                    minH={{ base: '30px', md: '75px' }}
                                    fontWeight={'600'}
                                    fontSize={'2xl'}
                                    // borderBottom={'3px solid black'}
                                    position={'relative'}
                                    _after={{
                                        position: 'absolute',
                                        height: '3px',
                                        width: '40px',
                                        content: '""',
                                        bottom: '-10px',
                                        left: 0,
                                        background: 'black',
                                    }}
                                >
                                    Uniwersalny z lewą kolumną
                                </Text>
                                <Text mt={8} mb={{ base: 6, lg: 0 }}>
                                    Wyróżnia się dwoma dobrze widocznymi drzewami menu. Idealny
                                    wybór dla sklepów potrzebujacych bardziej rozbudowanej
                                    nawigacji. 
                                </Text>
                            </Box>
                        </Flex>
                        {/* --- */}
                        <Flex
                            direction={'column'}
                            justifyContent={'space-between'}
                            backgroundColor={'#EEE'}
                            px={{
                                base: 8,
                                md: 4,
                            }}
                            py={8}
                            minH={{ lg: '350px' }}
                            w={{
                                base: '100%',
                                lg: '24%',
                            }}
                        >
                            <Box>
                                <Text
                                    minH={{ base: '30px', md: '75px' }}
                                    fontWeight={'600'}
                                    fontSize={'2xl'}
                                    // borderBottom={'3px solid black'}
                                    position={'relative'}
                                    _after={{
                                        position: 'absolute',
                                        height: '3px',
                                        width: '40px',
                                        content: '""',
                                        bottom: '-10px',
                                        left: 0,
                                        background: 'black',
                                    }}
                                >
                                    Hurtownia B2B
                                </Text>
                                <Text mt={8} mb={{ base: 6, lg: 0 }}>
                                    Zapewnia wygodne dodawanie do koszyka całych rozmiarów i wielu
                                    wariantów jednego produktu naraz. Hurtownicy go kochają!
                                </Text>
                            </Box>
                        </Flex>
                        {/* --- */}
                        <Flex
                            direction={'column'}
                            justifyContent={'space-between'}
                            backgroundColor={'#EEE'}
                            px={{
                                base: 8,
                                md: 4,
                            }}
                            py={8}
                            minH={{ base: '30px', md: '75px' }}
                            w={{
                                base: '100%',
                                lg: '24%',
                            }}
                        >
                            <Box>
                                <Text
                                    minH={{ base: '30px', md: '75px' }}
                                    fontWeight={'600'}
                                    fontSize={'2xl'}
                                    // borderBottom={'3px solid black'}
                                    position={'relative'}
                                    _after={{
                                        position: 'absolute',
                                        height: '3px',
                                        width: '40px',
                                        content: '""',
                                        bottom: '-10px',
                                        left: 0,
                                        background: 'black',
                                    }}
                                >
                                    Wersje tematyczne
                                </Text>
                                <Text mt={8} mb={{ base: 6, lg: 0 }}>
                                    Wersje Fashion i Decor idealnie sprawdzą się zarówno w branżach
                                    odzieżowych i home&decor, jak i meblach czy elektronice.
                                </Text>
                            </Box>
                        </Flex>
                    </Flex>
                </Flex>
                <TabsSection
                    title="Poznaj najważniejsze funkcjonalności szablonów Standard"
                    subtitle="Szablony Standard mają opracowane gotowe funkcjonalności, które obsłużysz wygodnie z panelu. 
                    Wykorzystaj sprawdzone i konwertujące rozwiązania od IdoSell, które pomogą ci wystartować w e-commerce."
                    tabsContent={[
                        {
                            tabName: 'Wygląd sklepu',
                            imgUrl: 'https://www.idosell.com/panel/file-gate.php?id=290615&ext=.webp',
                            list: [
                                {
                                    item: 'Gotowe szablony sklepu dostępne od ręki - nie musisz czekać i płacić',
                                },
                                {
                                    item: 'Możliwość dostosowania w podstawowym zakresie (zmiana głównego fontu, koloru i zaokrągleń elementów)',
                                },
                                {
                                    item: 'Dostęp do bezpłatnych integracji i obsługa najlepszych płatności oraz kurierów',
                                },
                                {
                                    item: 'Kilka wersji językowych + możliwość tłumaczenia AI i sprzedaży za granicą',
                                },

                                {
                                    item: 'Darmowy dostęp do wszystkich nowości produktowych IdoSell',
                                },
                            ],
                        },
                    ]}
                />
                <MigrationSection
                    image={{
                        url: 'https://www.iai-system.com/panel/file-gate.php?id=309285&ext=.jpeg',
                    }}
                    boxSide="right"
                    title="Rozpocznij sprzedaż
                    na zawsze aktualnym szablonie Standard"
                    subtitle="Na start otrzymujesz dostęp do bogatej biblioteki gotowych rozwiązań IdoSell"
                    // ctaButton={{
                    //     title: 'Dowiedz się więcej JAKI LINK??',
                    //     href: 'https://www.idosell.com/pl/sprzedaz-miedzynarodowa/',
                    //     variant: 'default',
                    // }}
                    position={'relative'}
                    _before={{
                        base: {
                            content: '""',
                            position: 'absolute',
                            height: '100%',
                            top: 0,
                            width: '100vw',
                            marginLeft: '50%',
                            left: '-50vw',
                            zIndex: -2,
                            backgroundColor: '#1AAC7A', // Replace with your theme color reference
                        },
                        lg: {
                            display: 'none',
                        },
                    }}
                >
                    <Text mb="30px">
                        W szablonie Standard otrzymujesz
                        <span> </span>
                        <b>bezpłatny dostęp do wszystkich nowości produktowych IdoSell. </b> Możesz
                        z powodzeniem prezentować produkty, które są skonfigurowane w zaawansowany
                        sposób. A to wszystko dzięki gotowym i sprawdzonym rozwiązaniom, które były
                        rozwijane od ponad 20 lat przez specjalistów IdoSell.
                        <br />
                        <br />W miarę potrzeb i rozwoju twojego biznesu masz zawsze możliwość
                        wprowadzenia zmian do szablonu, np. poprzez prace kontraktowe, pełny
                        redesign lub narzędzie Composer.
                    </Text>
                </MigrationSection>
                <Flex direction={'column'}>
                    <StyledHeading>Rozwijanie szablonu Standard</StyledHeading>
                    <StyledHighlight $style={'normal'}>
                        Naszą ideą jest maksymalizowanie sprzedaży naszych klientów, dlatego
                        udostępniamy ci najlepsze rozwiązania na rynku.
                    </StyledHighlight>
                    <Flex
                        flexWrap={'wrap'}
                        gap={{
                            base: 4,
                            lg: 0,
                        }}
                        mt={7}
                        justifyContent={'space-between'}
                    >
                        {/* Composer Lite */}
                        <Flex
                            direction={'column'}
                            justifyContent={'space-between'}
                            backgroundColor={'#EEE'}
                            px={{
                                base: 8,
                                md: 4,
                            }}
                            py={8}
                            minH={{ lg: '350px' }}
                            w={{
                                base: '100%',
                                lg: '24%',
                            }}
                        >
                            <Box>
                                <Text>Zmiany podstawowe</Text>
                                <Text
                                    minH={{ base: '30px', md: '75px' }}
                                    fontWeight={'600'}
                                    fontSize={'2xl'}
                                    position={'relative'}
                                    _after={{
                                        position: 'absolute',
                                        height: '3px',
                                        width: '40px',
                                        content: '""',
                                        bottom: '-10px',
                                        left: 0,
                                        background: 'black',
                                    }}
                                >
                                    Composer Lite
                                </Text>
                                <Text mt={8} mb={{ base: 6, lg: 0 }}>
                                    To narzędzie optymalne dla małych biznesów, które nie mają
                                    jeszcze dokładnie sprecyzowanych potrzeb. Skorzystaj z gotowych
                                    kompozycji zupełnie za darmo!
                                </Text>
                            </Box>
                        </Flex>
                        {/* Prace kontraktowe */}
                        <Flex
                            direction={'column'}
                            justifyContent={'space-between'}
                            backgroundColor={'#EEE'}
                            px={{
                                base: 8,
                                md: 4,
                            }}
                            py={8}
                            minH={{ lg: '350px' }}
                            w={{
                                base: '100%',
                                lg: '24%',
                            }}
                        >
                            <Box>
                                <Text>Zmiany zaawansowane</Text>
                                <Text
                                    minH={{ base: '30px', md: '75px' }}
                                    fontWeight={'600'}
                                    fontSize={'2xl'}
                                    position={'relative'}
                                    _after={{
                                        position: 'absolute',
                                        height: '3px',
                                        width: '40px',
                                        content: '""',
                                        bottom: '-10px',
                                        left: 0,
                                        background: 'black',
                                    }}
                                >
                                    Prace kontraktowe
                                </Text>
                                <Text mt={8} mb={{ base: 6, lg: 0 }}>
                                    Skorzystaj z wiedzy i doświadczenia specjalistów. Otrzymasz
                                    dedykowanego opiekuna, który będzie odpowiedzialny za wszystkie
                                    zmiany w twoim e-sklepie.
                                </Text>
                            </Box>
                        </Flex>
                        {/* Pełny redesign */}
                        <Flex
                            direction={'column'}
                            justifyContent={'space-between'}
                            backgroundColor={'#EEE'}
                            px={{
                                base: 8,
                                md: 4,
                            }}
                            py={8}
                            minH={{ lg: '350px' }}
                            w={{
                                base: '100%',
                                lg: '24%',
                            }}
                        >
                            <Box>
                                <Text>Wiesz, czego potrzebujesz?</Text>
                                <Text
                                    minH={{ base: '30px', md: '75px' }}
                                    fontWeight={'600'}
                                    fontSize={'2xl'}
                                    position={'relative'}
                                    _after={{
                                        position: 'absolute',
                                        height: '3px',
                                        width: '40px',
                                        content: '""',
                                        bottom: '-10px',
                                        left: 0,
                                        background: 'black',
                                    }}
                                >
                                    Pełny redesign
                                </Text>
                                <Text mt={8} mb={{ base: 6, lg: 0 }}>
                                    Redesign polega na pobraniu (na nowo) najnowszego szablonu
                                    Standard i zbudowaniu na nim nowego e-sklepu w oparciu o
                                    doświadczenia z poprzedniego biznesu.
                                </Text>
                            </Box>
                        </Flex>
                        {/* Composer Pro */}
                        <Flex
                            direction={'column'}
                            justifyContent={'space-between'}
                            backgroundColor={'#EEE'}
                            px={{
                                base: 8,
                                md: 4,
                            }}
                            py={8}
                            minH={{ lg: '350px' }}
                            w={{
                                base: '100%',
                                lg: '24%',
                            }}
                        >
                            <Box>
                                <Text>Masz swoich deweloperów?</Text>
                                <Text
                                    minH={{ base: '30px', md: '75px' }}
                                    fontWeight={'600'}
                                    fontSize={'2xl'}
                                    position={'relative'}
                                    _after={{
                                        position: 'absolute',
                                        height: '3px',
                                        width: '40px',
                                        content: '""',
                                        bottom: '-10px',
                                        left: 0,
                                        background: 'black',
                                    }}
                                >
                                    Composer Pro
                                </Text>
                                <Text mt={8} mb={{ base: 6, lg: 0 }}>
                                    Profesjonalne zaprojektowanie twojego e-sklepu bez ograniczeń.
                                    Dzięki temu narzędziu stworzysz w pełni spersonalizowane
                                    kompozycje oraz własne komponenty.
                                </Text>
                            </Box>
                        </Flex>
                    </Flex>
                </Flex>
                <Flex
                    flexDirection={{
                        base: 'column',
                        md: 'row',
                    }}
                    alignItems={'center'}
                    justifyContent={'space-between'}
                >
                    <Flex
                        flexDirection={'column'}
                        alignItems={'flex-start'}
                        gap={5}
                        maxW={{
                            base: '100%',
                            md: '40%',
                        }}
                    >
                        <Text fontSize={'3xl'} fontWeight={'bold'}>
                            Composer
                        </Text>
                        <Text fontSize={'lg'}>
                            Composer to narzędzie, z którym samodzielnie zaprojektujesz sklep
                            internetowy.
                        </Text>
                        <Text fontSize={'sm'}>
                            Zbuduj unikalny wizerunek marki i sam decyduj o tym, jak będzie wyglądał
                            twój e-sklep. Możliwości są nieograniczone!
                        </Text>
                        <StyledButton
                            href={'https://www.idosell.com/pl/composer/'}
                            style={'default'}
                            target="_blank"
                        >
                            Sprawdź szczegóły
                        </StyledButton>
                    </Flex>
                    <Flex
                        my={{
                            base: 6,
                            md: 0,
                        }}
                        flex={1}
                        flexDirection={{
                            base: 'row',
                            md: 'column',
                        }}
                        alignItems="center"
                        justifyContent="center"
                        h={{
                            base: 'auto',
                            md: '240px',
                        }}
                        w={{
                            base: '100%',
                            md: 'auto',
                        }}
                    >
                        <Hide below="md">
                            <Divider h={'full'} borderColor="#C8C8C8" orientation="vertical" />
                        </Hide>
                        <Hide above="md">
                            <Divider w={'full'} borderColor="#C8C8C8" orientation="horizontal" />
                        </Hide>
                        <Text m={4}>lub</Text>
                        <Hide below="md">
                            <Divider h={'full'} borderColor="#C8C8C8" orientation="vertical" />
                        </Hide>
                        <Hide above="md">
                            <Divider w={'full'} borderColor="#C8C8C8" orientation="horizontal" />
                        </Hide>
                    </Flex>
                    <Flex
                        flexDirection={'column'}
                        alignItems={'flex-start'}
                        gap={5}
                        maxW={{
                            base: '100%',
                            md: '40%',
                        }}
                    >
                        <Text fontSize={'3xl'} fontWeight={'bold'}>
                            Prace kontraktowe
                        </Text>
                        <Text fontSize={'lg'}>
                            Skorzystaj z cyklicznych lub pojedynczych prac kontraktowych i
                            wykorzystaj wiedzę ekspertów.
                        </Text>
                        <Text fontSize={'sm'}>
                            Zakres prac, które możemy wykonać, jest bardzo szeroki. Są to m.in.
                            zmiany w kodzie, user experience czy optymalizacja konwersji.
                        </Text>
                        <StyledButton
                            href={'https://www.idosell.com/pl/kontakt-idosell/'}
                            style={'default'}
                            target="_blank"
                        >
                            Sprawdź szczegóły
                        </StyledButton>
                    </Flex>
                </Flex>
                <Divider borderColor="#C8C8C8" orientation="horizontal" />
                <ContactSection />
            </Flex>
        </ThemeProvider>
    );
}
